export const BOOLEAN_SIGNAL_THRESHOLD = 0.5;

export const toBinarySignalState = (value: number): 0 | 1 =>
  value >= BOOLEAN_SIGNAL_THRESHOLD ? 1 : 0;
